import script from "./AllContactsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllContactsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__